import ProcessingStage from "./ProcessingStage";

export default ProcessingStage;